// Path: ./src/utils/dtoUtil/getMontrealStores.ts
import { GfStore } from "@swagger/typescript-fetch-goflyer";

export function getMontrealStores(stores: GfStore[]): GfStore[] {
  const results = stores.filter((store) => {
    // Check if the store has storeTags and if any of them have the name 'Montreal'
    return store.storeTag?.some((tag) => tag.name === "Montreal") ?? false;
  });
  return results;
}
